var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPedestrian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3,20.7c5,0.4,9.4-3.4,9.8-8.4c0.4-5-3.3-9.4-8.4-9.8c-5-0.4-9.4,3.3-9.8,8.4C58.6,15.9,62.3,20.3,67.3,20.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6,24.4c1.8-1.2,4-2.1,6.4-1.9c3.1,0.3,5.7,2.2,7.3,4.6l9.2,18.2L95,54c1.1,0.8,1.7,2.2,1.6,3.6 c-0.2,2.3-2.2,3.9-4.4,3.8c-0.7,0-1.2-0.3-1.9-0.6l-13.7-9.4c-0.4-0.4-0.8-0.8-1-1.2l-3.4-6.8L68,61.4l16.2,19.1 c0.4,0.6,0.6,1.3,0.8,2l4.4,23.1c0,0.5,0.1,0.8,0,1.3c-0.3,3.4-3.2,5.9-6.7,5.7c-2.8-0.2-4.9-2.3-5.6-4.9L73,86L59.9,71.6l-3.1,14 c-0.1,0.7-1,2-1.2,2.6L43,109.5c-1.3,2-3.4,3.2-5.8,3c-3.4-0.3-5.9-3.2-5.7-6.7c0.1-1,0.5-2,0.8-2.6l11.7-19.7l9.7-43.3l-6.4,5.2 l-3.4,15.4c-0.4,2-2.2,3.6-4.4,3.4c-2.2-0.2-4-2.1-3.8-4.4c0-0.2,0.1-0.4,0.1-0.5l4-18c0.2-0.8,0.7-1.5,1.3-2L59.6,24.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 89.3,
    width: 9.4,
    height: 7.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 89.3,
    width: 9.4,
    height: 7.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1,
    y: 89.3,
    width: 9.4,
    height: 7.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7,
    y: 89.3,
    width: 9.4,
    height: 7.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 114.2,
    y: 89.3,
    width: 9.4,
    height: 7.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 116.5,
    width: 9.4,
    height: 7.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 116.5,
    width: 9.4,
    height: 7.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6,
    y: 116.5,
    width: 9.4,
    height: 7.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 77.1,
    y: 116.5,
    width: 9.4,
    height: 7.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1,
    y: 116.5,
    width: 9.4,
    height: 7.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7,
    y: 116.5,
    width: 9.4,
    height: 7.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 114.2,
    y: 116.5,
    width: 9.4,
    height: 7.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestrian);
export default __webpack_public_path__ + "static/media/pedestrian.dbd6300084b463380c9b079df4b81b7d.svg";
export { ForwardRef as ReactComponent };